/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import AnalyticsService from 'cio/services/analytics';
import MessageLibraryItemModel from 'cio/models/message-library-item';

interface MessageRowMessageParentArgs {
  message: MessageLibraryItemModel;
}

export default class MessageRowMessageParent extends Component<MessageRowMessageParentArgs> {
  @service analytics!: AnalyticsService;

  get parentRoute() {
    if (this.args.message.belongsToCampaign) {
      return 'campaigns.campaign';
    } else if (this.args.message.belongsToNewsletter) {
      return 'broadcasts.newsletter';
    } else if (this.args.message.belongsToTransactional) {
      return 'transactional.message';
    } else {
      return undefined;
    }
  }

  @action
  trackMessageParentSelected() {
    this.analytics.track('library', 'message_parent_selected');
  }
}
